<template>
  <div class="register-page">
    <section class="register-section">
      <div class="register-container">
        <div class="register-card">
          <div class="register-card__top-image">
            <div class="register-card__top-image__overlay"></div>
            <div class="register-card__top-image__content">
              <h1>Zarejestruj konto w m2VET</h1>
              <p>Wybierz typ konta i dołącz do platformy w kilku prostych krokach.</p>
            </div>
          </div>

          <div class="register-card__top">
            <a href="#info" class="register-page-wrapper__link">Jak chcesz się zarejestrować?</a>

            <div class="register-page-wrapper__mode-button">
              <button :class="selectedMode=='priv' ? 'register-page-wrapper__mode-button__selected' : ''" @click="() => { selectedMode='priv'; firmRegistration=false }">Właściciel zwierzęcia</button>
              <button :class="selectedMode=='biz' ? 'register-page-wrapper__mode-button__selected' : ''" @click="() => { selectedMode='biz'; firmRegistration=false }">Specjalista</button>
              <button :class="selectedMode=='firm' ? 'register-page-wrapper__mode-button__selected' : ''" @click="() => { selectedMode='firm'; firmRegistration=true }">Placówka</button>
            </div>
          </div>

          <div class="register-page-wrapper__content">
            <Form @submit="handleRegister" :validation-schema="schema" v-if="!firmRegistration">
              <div>
                <div class="form-group">
                  <label for="email">Email <span class="required">(wymagane)</span></label>
                  <Field name="email" type="email" class="form-control" autocomplete="email" />
                  <ErrorMessage name="email" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="firstname">Imię <span class="required">(wymagane)</span></label>
                  <Field name="firstname" type="text" class="form-control" autocomplete="name"/>
                  <ErrorMessage name="firstname" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="lastname">Nazwisko <span class="required">(wymagane)</span></label>
                  <Field name="lastname" type="text" class="form-control" autocomplete="family-name"/>
                  <ErrorMessage name="lastname" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="password">Hasło <span class="required">(wymagane)</span></label>
                  <Field name="password" type="password" class="form-control" autocomplete="new-password"/>
                  <ErrorMessage name="password" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="passwordConfirmation">Potwierdź hasło <span class="required">(wymagane)</span></label>
                  <Field id="passwordConfirmation" name="passwordConfirmation" type="password" class="form-control" />
                  <ErrorMessage name="passwordConfirmation" class="error-feedback" />
                </div>

                <div class="form-group" v-if="selectedMode=='biz'">
                  <label for="name">Nazwa działalności</label>
                  <Field name="name" type="text" class="form-control" autocomplete="organization"/>
                  <ErrorMessage name="name" class="error-feedback" />
                </div>

                <div class="form-group" v-if="selectedMode=='biz'">
                  <label for="phone">Numer telefonu</label>
                  <Field name="phone" type="tel" class="form-control" autocomplete="tel"/>
                  <ErrorMessage name="phone" class="error-feedback" />
                </div>

                <div class="form-group" v-if="selectedMode=='biz'">
                  <label for="category">Kategoria</label>
                  <Field name="category_id" as="select" class="form-control" v-model="selectedCategory">
                    <option :value="category.id" v-for="category in categories" :key="category.id">{{ category.name }}</option>
                  </Field>
                  <ErrorMessage name="category" class="error-feedback" />
                </div>

                <div class="form-group consent-group">
                  <label>
                    Rejestrując się, akceptujesz
                    <RouterLink to="/statute">regulamin</RouterLink>
                    i
                    <RouterLink to="/privacy">politykę prywatności</RouterLink>
                    serwisu.
                  </label>

                  <span>{{ !isRecommendEmailOpen ? 'Czy ktoś polecił Ci m2VET?' : 'Wpisz adres e-mail osoby polecającej' }}</span>
                  <span v-if="!isRecommendEmailOpen" class="recommend-open-btn" role="button" @click="isRecommendEmailOpen = true">Tak</span>
                  <input v-if="isRecommendEmailOpen" type="text" class="recommend-email form-control" placeholder="adres e-mail" v-model="recommendEmail">

                  <button class="submit-btn" :disabled="loading">
                    <span v-show="loading" class="spinner-border"></span>
                    Zarejestruj się
                  </button>
                </div>
              </div>
            </Form>

            <Form @submit="handleFirmRegister" v-if="firmRegistration" :validation-schema="schemaFirm">
              <div>
                <div class="form-group">
                  <label for="email">email</label>
                  <Field name="email" type="email" class="form-control" autocomplete="email"/>
                  <ErrorMessage name="email" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="name">Nazwa działalności</label>
                  <Field name="name" type="text" class="form-control" autocomplete="organization"/>
                  <ErrorMessage name="name" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="password">hasło</label>
                  <Field name="password" type="password" class="form-control" autocomplete="new-password"/>
                  <ErrorMessage name="password" class="error-feedback" />
                </div>

                <div class="form-group">
                  <label for="passwordConfirmation">Potwierdź hasło</label>
                  <Field id="passwordConfirmation" name="passwordConfirmation" type="password" class="form-control" />
                  <ErrorMessage name="passwordConfirmation" class="error-feedback" />
                </div>

                <div class="form-group consent-group">
                  <label>
                    Rejestrując się, akceptujesz
                    <RouterLink to="/statute">regulamin</RouterLink>
                    i
                    <RouterLink to="/privacy">politykę prywatności</RouterLink>
                    serwisu.
                  </label>

                  <span>{{ !isRecommendEmailOpen ? 'Czy ktoś polecił Ci m2VET?' : 'Wpisz adres e-mail osoby polecającej' }}</span>
                  <span v-if="!isRecommendEmailOpen" class="recommend-open-btn" role="button" @click="isRecommendEmailOpen = true">Tak</span>
                  <input v-if="isRecommendEmailOpen" type="text" class="recommend-email form-control" placeholder="adres e-mail" v-model="recommendEmail">

                  <button class="submit-btn" :disabled="loading">
                    <span v-show="loading" class="spinner-border"></span>
                    Zarejestruj się
                  </button>
                </div>
              </div>
            </Form>

            <div class="info-container" id="info">
              <h3>Właściciel zwierzęcia</h3>
              <p>
                Jeśli chcesz mieć dostęp do funkcji przeznaczonych dla właścicieli zwierząt
                (wizyty, ogłoszenia, wiadomości, zalecenia), ten rodzaj konta jest dla Ciebie.
                Dzięki temu kontu umówisz się na wizyty, umieścisz ogłoszenia sprzedaży i przejrzysz
                zalecenia dla Twojego pupila.
              </p>

              <h3>Specjalista</h3>
              <p>
                Prowadzisz działalność lub po prostu przyjmujesz klientów w branży zwierzęcej?
                Ten rodzaj konta jest dla Ciebie. Dzięki kontu usługodawcy w m2VET będziesz
                mógł/mogła dodawać usługi i prowadzić do nich kalendarz. Możliwe będzie dodawanie
                ogłoszeń i zaleceń dla Twoich klientów. Ponadto będziesz posiadać własną wizytówkę biznesu.
              </p>

              <h3>Placówka</h3>
              <p>
                Ten rodzaj konta skierowany jest do placówek, w których przyjmują specjaliści.
                Konto to daje możliwość stworzenia własnej wizytówki i przypisania specjalistów,
                którzy przyjmują w placówce.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import axios from 'axios';
import { RouterLink } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default{
  name:'RegistrationPage',
  setup () {
    useMeta({
      title: 'Zarejestruj się',
      meta: [{ name: 'robots', Name: 'robots', content: 'all' }]
    });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data(){
    const schema = yup.object().shape({
      email: yup
          .string()
          .required("email jest wymagany")
          .email("email jest nieprawidłowy")
          .max(50, "maksymalnie 50 znaków")
          .min(6, "minimum 6 znaków"),
      firstname: yup
          .string()
          .required("imię jest wymagane")
          .min(3, "minimum 3 znaki")
          .max(30, "maksymalnie 30 znaków"),
      lastname: yup
          .string()
          .required("nazwisko jest wymagane")
          .min(3, "minimum 3 znaki")
          .max(30, "maksymalnie 40 znaków"),
      password: yup
          .string()
          .required("hasło jest wymagane")
          .min(8, "minimum 8 znaków")
          .max(40, "maksymalnie 40 znaków"),
      passwordConfirmation: yup
          .string()
          .required("potwierdź hasło")
          .oneOf([yup.ref('password')], 'Hasła nie są takie same'),
      name: yup
          .string()
          .min(3, "minimum 3 znaki")
          .max(20, "maksymalnie 20 znaków"),
      phone: yup
          .string()
          .length(9, "wpisz numer telefonu bez kierunkowego i bez spacji")
          .matches(/(^[0-9]*$)/, 'nieprawidłowy numer telefonu')
    });

    const schemaFirm = yup.object().shape({
      email: yup
          .string()
          .required("email jest wymagany")
          .email("email jest nieprawidłowy")
          .max(50, "maksymalnie 50 znaków")
          .min(6, "minimum 6 znaków"),
      password: yup
          .string()
          .required("hasło jest wymagane")
          .min(8, "minimum 8 znaków")
          .max(40, "maksymalnie 40 znaków"),
      passwordConfirmation: yup
          .string()
          .required("potwierdź hasło")
          .oneOf([yup.ref('password')], 'Hasła nie są takie same'),
      name: yup
          .string()
          .required("nazwa jest wymagana")
          .min(3, "minimum 3 znaki")
          .max(20, "maksymalnie 20 znaków"),
    });

    return{
      selectedMode: 'biz',
      loading: false,
      schema,
      schemaFirm,
      categories: [],
      selectedCategory: '',
      firmRegistration: false,
      isRecommendEmailOpen: false,
      recommendEmail: ''
    };
  },
  components: {
    Form,
    Field,
    ErrorMessage,
    RouterLink
  },
  computed:{
    loggedIn() {
      return this.authStore.loggedIn;
    },
  },
  mounted(){
    if (this.loggedIn) {
      const user = JSON.parse(localStorage.getItem('userm2VET'));
      if(user.data.role == 3){
        this.$router.push(`/profile`);
      }else if(user.data.role == 2){
        this.$router.push(`/dla-biznesu/profile`);
      }else if(user.data.role == 4){
        this.$router.push(`/dla-biznesu/employee-profile`);
      }else if(user.data.role == 1){
        this.$router.push(`/admin-profile`);
      }else if(user.data.role == 5){
        this.$router.push('/firm-profile');
      }
    }
    this.getCategories();
  },
  methods:{
    handleRegister(user, { resetForm }) {
      user.role_id = this.selectedMode === 'priv' ? 3 : 2;
      if (this.selectedMode === 'biz') {
        user.category_id = this.selectedCategory || user.category_id;
      }
      if(this.recommendEmail){
        user.recommender_email = this.recommendEmail;
      }

      if(user.role_id == 2 && (!user.name || !user.phone)){
        this.appStore.setIsAlert('Wypełnij nazwę firmy i telefon');
        return;
      }

      this.loading = true;
      this.authStore.register(user).then(
          () => {
            this.loading = false;
            resetForm();
            this.appStore.setIsSuccess('Na Twój adres e-mail wysłaliśmy link potwierdzający. Kliknij go.');
            this.$router.push('/');
          },
          (error) => {
            this.loading = false;
            if(String(error?.response?.status || '').charAt(0) == '4'){
              this.appStore.setIsAlert('Wypełnij wszystkie pola');
            }else if(String(error?.response?.status || '').charAt(0) == '5'){
              this.appStore.setIsAlert('Użytkownik o podanym adresie e-mail już istnieje');
            }else{
              this.appStore.setIsAlert('Wystąpił błąd podczas rejestracji');
            }
          }
      );
    },

    handleFirmRegister(user, { resetForm }){
      user.role_id = 5;
      if(this.recommendEmail){
        user.recommender_email = this.recommendEmail;
      }

      this.loading = true;
      this.authStore.register(user).then(() => {
        this.loading = false;
        resetForm();
        this.appStore.setIsSuccess('Na Twój adres e-mail wysłaliśmy link potwierdzający. Kliknij go.');
        this.$router.push('/');
      }).catch(error => {
        if (error.response && [400, 422].includes(error.response.status)) {
          this.appStore.setIsAlert(error.response.data.message);
        } else {
          this.appStore.setIsAlert('Wystąpił błąd podczas rejestracji');
        }
      }).finally(() => {
        this.loading = false;
      });
    },

    getCategories(){
      axios.get('/Categories').then(res => {
        this.categories = [];
        res.data.forEach((item) => {
          this.categories.push({
            name: item.name,
            id: `${item.id}`
          });
        });
        if (this.categories.length > 0) {
          this.selectedCategory = this.categories[this.categories.length - 1].id;
        }
      });
    }
  }
}
</script>

<style scoped lang='scss'>
.register-page{
  background: #ffffff;
  min-height: calc(100vh - 160px);
}

.register-section{
  padding: 28px 0 40px;
}

.register-container{
  width: min(1200px, calc(100% - 32px));
  margin: 0 auto;
}

.register-card{
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 15px 40px rgba(0,0,0,.12);
  overflow: hidden;

  &__top-image{
    position: relative;
    min-height: 210px;
    background-image: url('https://images.unsplash.com/photo-1583337130417-3346a1be7dee?q=80&w=1920&auto=format&fit=crop');
    background-size: cover;
    background-position: center;

    &__overlay{
      position: absolute;
      inset: 0;
      background: rgba(31, 41, 55, .68);
    }

    &__content{
      position: relative;
      z-index: 1;
      color: #fff;
      padding: 28px 24px;

      h1{
        margin: 0 0 8px;
        font-size: clamp(2.6rem, 4vw, 4rem);
      }

      p{
        margin: 0;
        font-size: 1.7rem;
        color: #e5e7eb;
      }
    }
  }

  &__top{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    margin-bottom: 18px;
    padding: 24px 24px 0;
  }
}

.register-page-wrapper__link{
  font-size: 1.5rem;
  color: #10b981;
  text-decoration: none;
}
.register-page-wrapper__link:hover{
  text-decoration: underline;
}

.register-page-wrapper__mode-button{
  width: min(880px, 100%);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;

  button{
    background: #fff;
    padding: 11px 10px;
    border-radius: 10px;
    border: 1px solid #d1d5db;
    cursor: pointer;
    font-size: 1.5rem;
    transition: .2s;

    &:hover{
      border-color: #10b981;
      color: #10b981;
    }
  }

  &__selected{
    background-color: #ecfdf5 !important;
    border-color: #10b981 !important;
    color: #047857 !important;
    font-weight: 700;
  }
}

.register-page-wrapper__content{
  width: min(880px, 100%);
  margin: 0 auto;
  padding: 0 24px 62px;

  form > div{
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
}

.form-group{
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  label{
    font-size: 1.5rem;
    color: #374151;
    display: block;
  }

  a{
    color: #10b981;
  }
}

.form-control{
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 1.6rem;
  color: #1f2937;
  box-sizing: border-box;
  transition: border-color .2s ease, box-shadow .2s ease;
}

.form-control:focus{
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 1px #10b981;
}

.error-feedback{
  font-size: 1.3rem;
  color: #dc2626;
}

.consent-group{
  margin-top: 8px;

  label {
    display: block;
  }

  span{
    font-size: 1.4rem;
    color: #4b5563;
  }
}

.recommend-open-btn{
  background-color: #f97316;
  color: #fff !important;
  width: fit-content;
  padding: 6px 10px;
  border-radius: 8px;
  cursor: pointer;
}

.submit-btn{
  margin-top: 6px;
  background: #10b981;
  color: #fff;
  border: none;
  border-radius: 8px;
  min-height: 46px;
  padding: 0 18px;
  font-size: 1.6rem;
  font-weight: 700;
  cursor: pointer;
  transition: .2s;
}

.submit-btn:hover{
  background: #059669;
}

.submit-btn:disabled{
  opacity: .7;
  cursor: not-allowed;
}

.info-container{
  margin-top: 36px;
  border-top: 1px solid #e5e7eb;
  padding-top: 20px;

  h3{
    color: #111827;
    margin: 14px 0 8px;
  }

  p{
    color: #4b5563;
    line-height: 1.6;
    margin: 0;
    font-size: 1.4rem;
  }
}

@keyframes spinner-border {
  to { transform: rotate(360deg); }
}

.spinner-border {
  display: inline-block;
  width: 15px;
  height: 15px;
  vertical-align: text-bottom;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border .75s linear infinite;
  margin-right: 10px;
}

@media (max-width: 880px){
  .register-card{
    &__top{
      padding: 16px 16px 0;
    }
  }

  .register-page-wrapper__mode-button{
    grid-template-columns: 1fr;
  }

  .register-page-wrapper__content{
    padding: 0 16px 16px;
  }
}
</style>